import React, { useEffect, useState } from 'react';
import Spinner from '@atlaskit/spinner';
import styled from '@emotion/styled';
import { HashRouter } from 'react-router-dom';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useDevopsState } from '../';
import {
  DevopsFormLoggedIn,
  DevopsFormLoggedOutDeferredPassword
} from './view';

declare global {
  interface Window {
    grecaptcha: {
      execute: (wigitId?: any) => any;
      render: (val?: any, data?: any) => any;
      reset: (wigitId?: any) => any;
    };
  }
}

export function DevopsFormView() {
  const { userInfo, productKeys } = useDevopsState();
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const [gRecaptchaResponse, setGRecaptchaResponse] = useState<string>('');

  useEffect(() => {
    const cartedProducts = productKeys.map((k) => k.product);
    createAnalyticsEvent({
      eventName: 'bxp.formCloudSignup.viewedCheckoutStep',
      eventComponent: 'form',
      event: 'viewed',
      data: {
        cartedProducts,
        intendedProduct: cartedProducts[0]
      }
    }).fire();
    createAnalyticsEvent({
      eventName: 'bxp.formCloudSignup.addedProduct',
      eventComponent: 'form',
      event: 'viewed',
      data: {
        cartedProducts
      }
    }).fire();
  }, []);

  switch (userInfo?.isLoggedIn) {
    case true:
      return (
        <HashRouter basename="/">
          <DevopsFormLoggedIn gRecaptchaResponse={gRecaptchaResponse} />
        </HashRouter>
      );
    case false:
      return (
        <HashRouter basename="/">
          <DevopsFormLoggedOutDeferredPassword
            setGRecaptchaResponse={setGRecaptchaResponse}
          />
        </HashRouter>
      );
    default:
      return (
        <SpinnerWrapper>
          <Spinner size="large" />
        </SpinnerWrapper>
      );
  }
}

const SpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
